import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'TEACHING_UPDATE',
    smsDelete : 'TEACHING_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        
        teaching:[],
      
        teaching_detail:{},

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        teachingLoading: false,
        teachingError: false,

        
       
        ...store
    },

    mutations : {
        ...mutations,

        SET_TEACHING(state, teaching) {
            state.teaching = teaching;
        },

        SET_TEACHING_DETAIL(state, detail) {
            state.teaching_detail = detail;
        },

        TEACHING_LOADING (state, loading) {
            state.teachingLoading = loading;
        },

        TEACHING_ERROR (state, hasError) {
            state.teachingError = hasError;
        },
        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },
        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },
    },

    actions: {
        //Teaching
        async addTeaching ({commit, dispatch}, payload) {
            commit('TEACHING_LOADING', true);
            commit('TEACHING_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_teaching, payload.teaching, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchTeaching')
               
                return response

            }catch (e) {
                commit('TEACHING_ERROR', true);
            }finally {
                commit('TEACHING_LOADING', false);
            }
        },

        async fetchTeachingDetail ({ commit },payload) {
            commit('TEACHING_LOADING', true);
            commit('TEACHING_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_teaching_details + payload, config);
                let response = result.data.data

                commit('SET_SLIDER_DETAIL', response);

            } catch(error) {
                commit('TEACHING_ERROR', true);
            }
            finally {
                commit('TEACHING_LOADING', false);
            }
        },



        async fetchTeaching ({ commit }) {
            commit('TEACHING_LOADING', true);
            commit('TEACHING_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.teaching_list, config);
                let response = result.data

                commit('SET_TEACHING', response.data);

            } catch(error) {
                commit('TEACHING_ERROR', true);
            }
            finally {
                commit('TEACHING_LOADING', false);
            }
        },


    
        async updateTeaching ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {

                let response = await axios.patch(V1API.update_teaching+payload.id, payload.teaching, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchTeaching')
                return response

            }catch (e) {
                commit('TEACHING_ERROR', true);
            }finally {
                commit('TEACHING_LOADING', false);
            }
        },

        
        async deleteTeaching({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.teaching_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchTeaching')
            
            return response
        },

    },

    getters: {}
}
